import { filterPanels } from 'common/api/v1/products';

import {
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
} from '../actionTypes';
import { addPanelsModalActions } from '../reducer';

export default ({
        brand,
        max_power,
        orderBy,
        page = 0,
        pageSize,
        searchText,
        sortBy,
    } = {}) =>
    (dispatch) => {
        dispatch(addPanelsModalActions[FETCH_ITEMS]());

        filterPanels({
            brand,
            max_power,
            orderBy,
            page: page + 1,
            perPage: pageSize,
            searchText,
            sortBy,
        })
            .then((response) =>
                dispatch(
                    addPanelsModalActions[FETCH_ITEMS_SUCCESS](response.data),
                ),
            )
            .catch((error) =>
                dispatch(
                    addPanelsModalActions[FETCH_ITEMS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
